import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";

import MDBox from "../components/MDBox/index.js";

export default function OthelloComboBox({ ...props }) {

    const { classes, items, label, labelliteral, fieldname, readonly, disabled, multiple, sinlabel } = props;

    const { t } = useTranslation();

    const [comboboxvalue, setcomboboxvalue] = useState(props.currentvalue);
    const [evento, setevento] = useState(false);

    const handleOnChange = (event) => {

        // this.setState({ [event.target.name]: event.target.value });
        //this.setState({ comboboxvalue: event.target.value, evento: true });

        setcomboboxvalue(event.target.value)
        setevento(true);

        if (props.onChange != null)
            props.onChange(event.target.value, event.target.name);
    };

    const getItemComboBox = (items, multiple) => {

        let res = "";

        if (items != null) {
            res = items.map((prop, key) => {
                return (<MenuItem
                    value={prop.valor}>{prop.name}
                </MenuItem>);
            });
        }

        return res;
    }


    let labelfinal = t != null && labelliteral != null ? t(labelliteral) : label;

    let itemscombo = getItemComboBox(items, multiple)

    let deshabilitado = disabled != null && disabled;

    let sololectura = readonly != null && readonly;

    //Si el que ha provocado el cambio es el evento entonces el valor del input es el que viene del evento, pero sino, el valor sera el de por defecto    
    let valor = evento ? comboboxvalue : props.currentvalue;

    //Si estamos en modo multiple y el valor es null debemos poner el arraya vacio
    if (multiple) {
        try {
            if (valor == null || valor == "")
                valor = [];
            else if (typeof valor === 'string' && valor != "") {
                if (valor.includes(",")) {
                    let final = [];
                    valor.split(",").forEach(x => final.push(parseInt(x)));
                    valor = final;
                }
                else
                    valor = [parseInt(valor)];
            }
        } catch
        {
            valor = [];
        }
    }

    //Limpiamos que el cambio ha sido por el evento, por si en otro lugar se ha realizado el deshacer, o al principio, que en esos casos debe tomar el de por defecto
    //evento = false;

    let doshrink = valor != null && (valor != "" || !isNaN(valor));

    return (
        <MDBox pt={1} pl={1} pr={1} >
            <FormControl variant="standard" fullWidth disabled={deshabilitado}>
                <MDBox pt={2.20} >
                    {sinlabel != null && sinlabel ? "" : <InputLabel style={{ fontSize: 14, fontWeight: 400 }} htmlFor={multiple != null && multiple ? "multiple-select" : "simple-select"} shrink={doshrink}>{labelfinal}</InputLabel>}
                </MDBox>
                <Select multiple={multiple != null ? multiple : false} sx={{ pb: 0.6 }}
                    value={valor}
                    onChange={(e) => handleOnChange(e)}
                    IconComponent={() => (
                        <ArrowDropDown />
                    )}
                    inputProps={{ name: fieldname, id: fieldname, readOnly: sololectura }}>
                    {itemscombo}

                </Select>
            </FormControl>
            {/*<OthelloToolTipIcon texto="Acceda a sus " icono={Help} />*/}
        </MDBox>
    );
}

OthelloComboBox.propTypes = {
    classes: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired, //{ name: nombre , valor : valor}   
    fieldname: PropTypes.string,
    labelliteral: PropTypes.string,
    label: PropTypes.string,
    currentvalue: PropTypes.object,
    onChange: PropTypes.object,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,//OJO- EL PONER DISABLED LO QUITA DE LOS RESULTADOS DEVUELTOS DEL FORM
    multiple: PropTypes.bool,
    sinlabel: PropTypes.bool,
};

